<template>
  <div class="container-fluid bg-white rounded">
    <div class="row justify-content-between align-items-center my-3 px-3">
      <div class="col-auto mt-4">
        <router-link to="/admin/create-wasiyyah" class="btn btn-success">
          <font-awesome-icon icon="backward" class="text-white back-icon" />
        </router-link>
      </div>

      <div class="col-auto mt-4">
        <a class="btn btn-success" @click="downloadPdf">
          <font-awesome-icon class="text-white" icon="download" />
        </a>
      </div>
    </div>

    <div class="row" ref="printSection">
      <!-- Paginated Sections (Each Page Contains 25 Lines) -->
      <div
        class="col-12 col-md-10 mt-4 mx-auto"
        :class="{ 'first-page': pageIndex === 0, 'second-page': pageIndex > 0 }"
        v-for="(page, pageIndex) in paginatedContent"
        :key="pageIndex"
        :ref="setPageRefs"
      >
        <div class="border rounded p-3" id="printable-section">
          <div class="row align-items-center" v-if="pageIndex === 0">
            <!-- First Section with QR Code and Barcode -->
            <div class="col-12" style="background: antiquewhite">
              <div class="row">
                <!-- Bar Code -->
                <div
                  class="col-6 col-md-2 d-flex flex-column justify-content-center mt-5 p-2"
                >
                  <BarcodePage class="vertical-barcode img-fluid mt-5" />
                </div>
                <!-- Centered Image -->
                <div
                  class="col-6 col-md-8 d-flex flex-column align-items-center"
                >
                  <img
                    src="@/assets/images/circle.png"
                    alt="First Page Image"
                    class="img-fluid"
                    style="max-width: 100%; height: auto"
                  />
                </div>
                <!-- QR code -->
                <div
                  class="col-6 col-md-2 d-flex flex-column justify-content-center mt-5"
                >
                  <QRCode class="img-fluid" />
                </div>
              </div>
            </div>
            <!-- Second Section with Bismillah Image -->
            <div class="col-12 text-center">
              <img
                src="@/assets/images/bismillah.png"
                alt="First Page Image"
                class="img-fluid"
                style="max-width: 60%; height: auto"
              />
            </div>
          </div>

          <div v-else>
            <div
              class="row align-items-center justify-content-between"
              style="background-color: antiquewhite; padding: 10px"
            >
              <div class="col-12 col-md-7 d-flex justify-content-start">
                <img
                  src="@/assets/images/wasiyah.png"
                  alt="Wasiyah Image"
                  class="img-fluid"
                  style="max-width: 100%; height: auto"
                />
              </div>
              <!-- Barcode on the left -->
              <div class="col-12 col-md-5 d-flex justify-content-end">
                <BarcodePage class="img-fluid" />
              </div>
            </div>
          </div>
          <!-- Dynamic Content for Each Page -->
          <div class="preview mt-4">
            <div v-for="(item, index) in page" :key="index">
              <h6 class="text-center p-1">{{ item.title }}</h6>
              <hr class="style-seven m-auto" />
              <p class="text-justify p-3">{{ item.content }}</p>
            </div>
          </div>

          <!-- Footer with Page Number -->
          <footer
            class="d-flex align-items-start text-success p-2 mt-auto"
            style="background-color: #fff6ed; color: grey"
          >
            Page {{ pageIndex + 1 }} of {{ totalPages }}
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiRepository from "@/services/ApiRepository";
import { toast } from "vue3-toastify";
import QRCode from "@/components/layouts/views/chart/QRCode";
import BarcodePage from "@/components/layouts/views/chart/BarCode";
// import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";
import jspdf from "jspdf";

export default {
  name: "wasiyyahPreview",
  data() {
    return {
      linesPerPageFirst: 17,
      linesPerPage: 25,
      pageRefs: [],
      wasiyyahPreviewOptions: [],
    };
  },
  components: {
    BarcodePage,
    QRCode,
  },
  computed: {
    // totalPages() {
    //   return Math.ceil(this.getTotalLines() / this.linesPerPage);
    // },
    totalPages() {
      // first page 15, subsequent 25
      let total = 0;
      let currentPage = 0;
      let currentLines = 0;

      for (let item of this.wasiyyahPreviewOptions) {
        const itemLines = item.content.split("\n").length + 2;

        const maxLines =
          currentPage === 0 ? this.linesPerPageFirst : this.linesPerPage;

        if (currentLines + itemLines > maxLines) {
          currentPage++;
          currentLines = 0;
        }
        currentLines += itemLines;
        total = currentPage + 1;
      }
      return total;
    },
    // paginatedContent() {
    //   const pages = [];
    //   let currentPage = [];
    //   let currentLines = 0;

    //   for (let item of this.wasiyyahPreviewOptions) {
    //     const itemLines = item.content.split("\n").length + 2; // Including title lines
    //     if (currentLines + itemLines > this.linesPerPage) {
    //       pages.push(currentPage); // Save full page
    //       currentPage = []; // Start new page
    //       currentLines = 0;
    //     }
    //     currentPage.push(item);
    //     currentLines += itemLines;
    //   }

    //   if (currentPage.length) {
    //     pages.push(currentPage); // Push remaining items
    //   }

    //   return pages;
    // },
    paginatedContent() {
      const pages = [];

      let currentPage = [];

      let currentLines = 0;

      for (let item of this.wasiyyahPreviewOptions) {
        const itemLines = item.content.split("\n").length + 2;

        const maxLines =
          pages.length === 0 ? this.linesPerPageFirst : this.linesPerPage;

        if (currentLines + itemLines > maxLines) {
          pages.push(currentPage);
          currentPage = []; // new page
          currentLines = 0;
        }
        currentPage.push(item);
        currentLines += itemLines;
      }
      if (currentPage.length) {
        pages.push(currentPage);
      }
      return pages;
    },
  },
  mounted() {
    this.wasiyyahPreview();
  },
  methods: {
    getTotalLines() {
      return this.wasiyyahPreviewOptions.reduce(
        (sum, item) => sum + item.content.split("\n").length + 4, // Count lines properly
        0
      );
    },

    setPageRefs(el) {
      if (el && !this.pageRefs.includes(el)) {
        this.pageRefs.push(el);
      }
    },

    wasiyyahPreview() {
      apiRepository.getWasiyyah().then((res) => {
        if (res || res.data) {
          this.wasiyyahPreviewOptions = res.data.filter(
            (item) => item.visible == "Y"
          );
          console.log("wasiyyah", this.wasiyyahPreviewOptions);
        } else {
          toast.error(res.data || "Data not found!");
        }
      });
    },
    // downloadPdf() {
    //   const originalLog = console.log;
    //   console.log = function () {}; // Suppress logs

    //   const element = this.$refs.printSection;

    //   const opt = {
    //     margin: [10, 10, 10, 10], // 10mm on all sides
    //     filename: "wasiyyah-legal.pdf",
    //     image: { type: "jpeg", quality: 0.98 },
    //     html2canvas: {
    //       scale: 2,
    //       useCORS: true,
    //       windowWidth: element.scrollWidth,
    //       scrollY: 0,
    //     },
    //     jsPDF: {
    //       unit: "mm",
    //       format: [216, 356], // Legal size in mm
    //       orientation: "portrait",
    //     },
    //     pagebreak: {
    //       mode: ["avoid-all", "css", "legacy"],
    //     },
    //   };

    //   html2pdf()
    //     .set(opt)
    //     .from(element)
    //     .save()
    //     .finally(() => {
    //       console.log = originalLog; // Restore logs
    //     });
    // },

    async downloadPdf() {
      if (this.pageRefs.length === 0) {
        console.error("Page elements not found.");
        return;
      }
      console.log("Page refs:", this.pageRefs);
      try {
        const pdf = new jspdf("p", "mm", [216, 356]);

        // A4 dimensions in mm
        // const pageWidth = 216;
        let firstPage = true;

        // Calculate rendered dimensions to match PDF's width
        for (let i = 0; i < this.pageRefs.length; i++) {
      const element = this.pageRefs[i];
      const canvas = await html2canvas(element, { scale: 2 });

      const imgData = canvas.toDataURL("image/jpeg", 0.98);
      const pageWidth = 216;
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * pageWidth) / canvas.width;

      if (!firstPage) {
        pdf.addPage([216, 356]);
      }
      pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
      firstPage = false;
    }
    pdf.save("wasiyyah-legal.pdf");
      } catch (error) {
        console.error("Error generating PDF:", error);
      }
    },
  },
};
</script>

<style>
.heading img {
  width: 60%;
}

.border {
  border: 1px solid #ddd;
  padding: 20px;
}

hr.style-eight {
  overflow: visible; /* For IE */
  padding: 0;
  border: none;
  border-top: medium double #ffffff;
  color: #ffffff;
  max-width: 50%;
  text-align: center;
}

hr.style-eight:after {
  content: "§";
  display: inline-block;
  position: relative;
  top: -0.9em;
  font-size: 1.5em;
  padding: 0 0.25em;
  background: #2b2727;
}

hr.style-seven {
  overflow: visible; /* For IE */
  height: 30px;
  max-width: 220px;
  border-style: solid;
  border-color: #009155;
  border-width: 1px 0 0 0;
  border-radius: 20px;
}

hr.style-seven:before {
  /* Not really supposed to work, but does */
  display: block;
  content: "";
  height: 30px;
  margin-top: -31px;
  border-style: solid;
  border-color: #009155;
  border-width: 0 0 1px 0;
  border-radius: 20px;
}

hr.style-six {
  overflow: visible; /* For IE */
  height: 30px;
  max-width: 320px;
  border-style: solid;
  border-color: #009155;
  border-width: 1px 0 0 0;
  border-radius: 20px;
}

hr.style-six:before {
  /* Not really supposed to work, but does */
  display: block;
  content: "";
  height: 30px;
  margin-top: -31px;
  border-style: solid;
  border-color: #009155;
  border-width: 0 0 1px 0;
  border-radius: 20px;
}

.first-hr {
  background: #fff;
  width: 350px;
  border: 0;
  border-bottom: 1px dashed #ccc;
  background: #999;
}

.rounded {
  position: relative;
  background: none;
}

.rounded::before {
  content: ""; /* Create a pseudo-element for the background */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("@/assets/images/background.png");
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0.2; /* Apply opacity only to the background */
  /* z-index: -1;*/ /* Place it behind the content */
}

/*Barcode and QR code style*/
.vertical-barcode {
  transform: rotate(
    270deg
  ); /* Rotates the barcode 90 degrees to make it vertical */
  transform-origin: center; /* Ensures the rotation happens around the center */
}
</style>
